var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FF6365"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 32C28.4183 32 32 28.4183 32 24C32 19.5817 28.4183 16 24 16C19.5817 16 16 19.5817 16 24C16 28.4183 19.5817 32 24 32ZM24 34C29.5228 34 34 29.5228 34 24C34 18.4772 29.5228 14 24 14C18.4772 14 14 18.4772 14 24C14 29.5228 18.4772 34 24 34Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19C23 18.4477 23.4477 18 24 18C24.5523 18 25 18.4477 25 19C26.6569 19 28 20.3431 28 22C28 22.5523 27.5523 23 27 23C26.4477 23 26 22.5523 26 22C26 21.4477 25.5523 21 25 21H22.7434C22.3328 21 22 21.3328 22 21.7434C22 22.0634 22.2048 22.3475 22.5083 22.4487L26.1241 23.6539C27.2444 24.0274 28 25.0757 28 26.2566C28 27.7717 26.7717 29 25.2566 29H25C25 29.5523 24.5523 30 24 30C23.4477 30 23 29.5523 23 29C21.3431 29 20 27.6569 20 26C20 25.4477 20.4477 25 21 25C21.5523 25 22 25.4477 22 26C22 26.5523 22.4477 27 23 27H25.2566C25.6672 27 26 26.6672 26 26.2566C26 25.9366 25.7952 25.6525 25.4917 25.5513L21.8759 24.3461C20.7556 23.9726 20 22.9243 20 21.7434C20 20.2283 21.2283 19 22.7434 19H23Z",
    fill: "#FCFCFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoin);
export default __webpack_public_path__ + "static/media/icon-coin.55ac6bc1.svg";
export { ForwardRef as ReactComponent };